import labels from '@/i18n/catalogues/memberBilling.en-GB.js';
import React from 'react';
import {useOptionalPrivanaI18n} from '@/i18n/PrivanaI18nProvider.jsx';

export default function AttributableCharges({charges=[], currency}) {
  const {t,locale}=useOptionalPrivanaI18n();
  if (!charges.length) return null;
  return <section className="rounded border p-4 space-y-2 mp-panel-card mp-attributable-charges">
    <h3 className="font-medium mp-panel-title">{t('memberBilling.linkedCharges')}</h3>
    {charges.map(charge=><div key={charge.id} className="flex justify-between gap-3 text-sm mp-attributable-charge">
      <div><p>{charge.description}</p><p>{t('memberBilling.billedTo',{payer:charge.billing_responsibility?.payerName || t('profileOverview.unavailable')})}</p></div>
      <div><p>{new Intl.NumberFormat(locale, (charge.currency || currency?.code) ? {style:'currency',currency:charge.currency || currency.code} : {minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(charge.original_amount))}</p><p>{t(`memberBilling.${Object.hasOwn(labels,`status_${charge.status}`)?`status_${charge.status}`:'status_unknown'}`)}</p></div>
    </div>)}
  </section>;
}
